import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import VerticalCampaignNavbar from "../components/VerticalCampaignNavbar/VerticalCampaignNavbar";
import CampaignAnalytics from "../components/CampaignAnalytics/CampaignAnalytics";
import LoginRequiredModal from "../components/LoginRequiredModal";
import "./css/HomeResponsive.css";

const Home = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [selected, setSelected] = useState(null);
  const [navbarCollapsed, setNavbarCollapsed] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const localUserId = localStorage.getItem("user_id");
    const loginTime = localStorage.getItem("login_time");
    const isValid =
      localUserId &&
      loginTime &&
      Date.now() - Number(loginTime) < 7 * 24 * 60 * 60 * 1000;

    if (isValid) {
      (async () => {
        try {
          const axios = (await import("axios")).default;
          // 1. 获取user_info
          const userInfoRes = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/user_info`,
            { user_id: localUserId },
          );
          const userInfo = userInfoRes.data;
          sessionStorage.setItem("userId", localUserId);
          sessionStorage.setItem("userName", userInfo.user_name);
          sessionStorage.setItem("userEmail", userInfo.user_email);
          sessionStorage.setItem("loggedIn", "true");
          // 2. 获取advertiser信息
          const advRes = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/advertiser?user_id=${localUserId}`,
          );
          if (advRes.data && advRes.data.advertiser) {
            sessionStorage.setItem(
              "advertiserId",
              advRes.data.advertiser.advertiser_id,
            );
            sessionStorage.setItem(
              "companyName",
              advRes.data.advertiser.company_name,
            );
            window.dispatchEvent(new Event("storage"));
            fetchCampaigns(advRes.data.advertiser.advertiser_id);
          } else {
            throw new Error("No advertiser info");
          }
        } catch (e) {
          localStorage.removeItem("user_id");
          localStorage.removeItem("login_time");
          sessionStorage.clear();
          setShowLoginModal(true);
        }
      })();
    } else {
      localStorage.removeItem("user_id");
      localStorage.removeItem("login_time");
      sessionStorage.clear();
      setShowLoginModal(true);
    }
  }, []);

  const fetchCampaigns = async (advertiserId) => {
    try {
      const axios = (await import("axios")).default;
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/campaign?advertiser_id=${advertiserId}`,
      );
      if (res.data && Array.isArray(res.data.campaigns)) {
        // 统一格式：id和name
        const campaignArr = res.data.campaigns.map((c) => ({
          id: c.campaign_id,
          name: c.name,
          raw: c, // 保留原始数据备用
        }));
        setCampaigns(campaignArr);
        sessionStorage.setItem("campaigns", JSON.stringify(campaignArr));
        if (campaignArr.length > 0) {
          setSelected(campaignArr[0].id);
          sessionStorage.setItem('selectedCampaignId', campaignArr[0].id);
        }
      }
    } catch (e) {
      console.error("获取campaigns失败", e);
    }
  };

  const handleLoginRedirect = () => {
    setShowLoginModal(false);
    navigate("/login");
  };

  // 监听navbar收缩/展开
  const handleNavbarToggle = (collapsed) => setNavbarCollapsed(collapsed);

  // 选中的campaign原始数据
  const selectedCampaign = campaigns.find((c) => c.id === selected)?.raw;

  // 在选中campaign时打印其info并更新sessionStorage
  useEffect(() => {
    if (selectedCampaign) {
      console.log("Selected campaign info:", selectedCampaign);
      sessionStorage.setItem('selectedCampaignId', selectedCampaign.campaign_id);
    }
  }, [selectedCampaign]);

  return (
    <>
      <LoginRequiredModal show={showLoginModal} onLogin={handleLoginRedirect} />
      <div
        className={`home-responsive-layout${navbarCollapsed ? " navbar-collapsed" : ""}`}
      >
        <VerticalCampaignNavbar
          selectedId={selected}
          onSelect={setSelected}
          onCollapseChange={handleNavbarToggle}
          campaigns={campaigns}
        />
        <div className="home-content-area">
          {selectedCampaign && (
            <CampaignAnalytics
              campaignName={selectedCampaign.name}
              campaignId={selectedCampaign.campaign_id}
              updated_at={selectedCampaign.updated_at}
              {...selectedCampaign}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Home;
